import React from "react";
import { Link, Icon } from "../../index";
import propTypes from "prop-types";
import intl from "react-intl-universal";
import "./ListInfoDropdownContent.scss";

const ListInfoDropdownContent = ({
  location,
  grupo,
  divisao,
  totalAfterSorting,
  total,
  visualizations,
  id,
}) => {
  return (
    <div>
      <div className="vg-info">
        <p>
          <Icon iconKey="location" />
          {location.descricao || location.pais}
        </p>
        <p>
          <Icon iconKey="buildings" />
          {divisao}
        </p>
        <p>
          <Icon iconKey="tag" />
          {grupo}
          <Link
            className="vg-link"
            moveTo="editar-grupo-vaga"
            params={{ codigo_da_vaga: id }}
          >
            {intl.get(
              `VAGAS.INFO.LINK_${grupo ? "EDITAR" : "ADICIONAR_GRUPO"}`
            )}
          </Link>
        </p>
      </div>
      <div className="vg-block-totals">
        <div className="vg-col-totals">
          <h4 className="vg-info-numbers">{visualizations || 0}</h4>
          <p className="vg-text-totals">
            {intl.get("VAGAS.INFO.TOTAL_VISUALIZACAO")}
          </p>
        </div>
        <div className="vg-col-totals">
          <h4 className="vg-info-numbers">{total || 0}</h4>
          <p className="vg-text-totals">
            {intl.get("VAGAS.INFO.TOTAL_INSCRITOS")}
          </p>
        </div>
        <div className="vg-col-totals">
          <h4 className="vg-info-numbers">{totalAfterSorting || 0}</h4>
          <p className="vg-text-totals">
            {intl.get("VAGAS.INFO.TOTAL_NOVOS_CANDIDATOS")}
          </p>
        </div>
      </div>
    </div>
  );
};

ListInfoDropdownContent.propTypes = {
  location: propTypes.shape({
    cidade: propTypes.string,
    estado: propTypes.string,
    pais: propTypes.string,
    descricao: propTypes.string,
  }),
  grupo: propTypes.string,
  divisao: propTypes.string,
  totalAfterSorting: propTypes.number,
  total: propTypes.number,
  visualizations: propTypes.number,
  id: propTypes.number.isRequired,
};

export default ListInfoDropdownContent;
